import { render, staticRenderFns } from "./PronounsSection.vue?vue&type=template&id=360ec0da"
import script from "./PronounsSection.vue?vue&type=script&lang=js"
export * from "./PronounsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports